<template>
  <div class="vehicleSelectWrapperComponent mt-4">
    <template v-if="! loading">
      <template v-if="! vehiclesData.length">
        <div class="text-center text-danger">{{ $t('key_no_vehicles_that_matches_your_criteria') }}</div>
      </template>
      <div v-else class="container-vehicles__wrapper">
        <template v-for="vehicle in vehiclesData" :key="vehicle.id">
          <VehicleCardComponent @click="$helpers.openModal($event, {id: 'selected-vehicle-' + vehicle.id}, 'custom-modal-backdrop-0')" :class="[vehicle.id === store.state.vehicle.selectedId ? isActive : null]">
            <template #seats>
              <div class="vehicle-card__header__data font-medium">{{ vehicle.seats }} {{ $t($helpers.wordEnding(vehicle.seats)) }}</div>
            </template>
            <template #image>
              <img class="vehicle-card__body__car-image" :src="vehicle.vehicle_main_image ? vehicle.vehicle_main_image.path : ''" alt="car-image">
            </template>
            <template #maker_model>
              <h5 class="fw-600 margin-bottom-0 align-self-start">{{ vehicle.make }} {{ vehicle.model }}</h5>
            </template>
            <template #price>
              <div class="font-big font-color align-self-start pb-3">{{ vehicle.price }} {{ $t('eur_h') }}</div>
            </template>
          </VehicleCardComponent>

          <Teleport to="body">
              <ModalComponent
                  :is-main-modal="false"
                  :show-link="true"
                  :id="'selected-vehicle-' + vehicle.id"
                  :z-index-custom="'z-index-custom-0'"
                  :backdrop="'custom-modal-backdrop-0'"
                  :body-overflow="'body-overflow'">
                <template #body-content>
                  <VehicleInfoWrapperComponent
                      :vehicle="vehicle"
                      :is-driver="store.state.order.withDriver"
                  ></VehicleInfoWrapperComponent>
                </template>
              </ModalComponent>
          </Teleport>
        </template>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import './vehicleSelectWrapper.scss';

import {defineComponent, type PropType} from 'vue';
import {useStore} from "vuex";
import axios from "axios";
import apiService from "../../services/apiService";

// @ts-ignore
import ModalComponent from "../../components/modal/ModalComponent.vue";
// @ts-ignore
import VehicleInfoWrapperComponent from "../../components/vehicleInfoWrapper/VehicleInfoWrapperComponent";
// @ts-ignore
import VehicleCardComponent from '../../components/vehicleCard/VehicleCardComponent.vue';

import type {IApiResponseVehicle} from "../../interfaces/apiResponseInterfaces/IApiResponseVehicle.interface";
import {ServiceTypes} from "../../interfaces/enums/ServiceTypes.enum";
import {routesConst} from "../../routes";
import {dateHelpers} from "../../helpers/dateHelpers";

export default defineComponent({
  name: 'VehicleSelectWrapperComponent',

  components: {
    ModalComponent,
    VehicleInfoWrapperComponent,
    VehicleCardComponent
  },

  props: {
    filteredVehicles: {
      type: Array as PropType<IApiResponseVehicle[]>,
      required: false,
      default: [],
    },
    isMainModal: {
      type: Boolean,
      default: true,
      required: false
    }
  },

  data() {
    return {
      vehiclesData: [] as IApiResponseVehicle[],
      isActive: 'vehicle-card-select-active',
      loading: false,
      currentRoute: this.$route.name
    }
  },

  watch: {
    filteredVehicles: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          this.vehiclesData = [...this.filteredVehicles];
        } else {
          this.vehiclesData = [];
        }
      },
    }
  },

  setup() {
    const store = useStore();

    return {
      store
    }
  },

  created() {
    if (!this.store.state.order.withDriver) {
        this.loadVehiclesList();
    }
      
    // Quick solution for CalendarComponent.vue mounted to be loaded first and then this place.
    setTimeout(() => {
        if (this.store.state.order.withDriver && (this.$route.name === routesConst.ORDER || this.$route.name === routesConst.CHOOSE_CUSTOM_ROUTE )) {
            this.loadVehiclesList();
        }
    });
  },
  methods: {
    loadVehiclesList() {
      if (this.loading) {
        return;
      }
      this.loading = true;

      let passengers = 0;
      let pickup = <string|null>null;
      let dropOff = <string|null>null;

      const orderState = this.store.state.order;

      switch (orderState.serviceType) {
        case ServiceTypes.SERVICE_RENT:
          if (! orderState.withDriver) {
            let state = this.store.state.orderFalseDriver;

            passengers = state.passengerCount;
            // pickup = state.pickupDate.split('T')[0] + ' ' + state.pickupTime;
            // dropOff = state.endDate.split('T')[0] + ' ' + state.endTime;
            pickup = dateHelpers.dateToDisplay(state.pickupDate) + ' ' + state.pickupTime;
            dropOff = dateHelpers.dateToDisplay(state.endDate) + ' ' + state.endTime;

          } else {
            let state = this.store.state.orderTrueDriver;
            let customDateState = this.store.state.orderTrueDriverDates;
            let customTimeState = this.store.state.orderTrueDriver

            passengers = state.passengerCount;
            pickup = dateHelpers.dateToDisplay(customDateState.selectedStartDate) + ' ' + customTimeState.customRoutes[0].arrivalTime;
            dropOff = dateHelpers.dateToDisplay(customDateState.selectedEndDate) + ' ' + customTimeState.customRoutes[customTimeState.customRoutes.length - 1].arrivalTime;
            // TODO calculate pickup + total duration for true driver to know the drop off car date.
            // What about the tresholds ?
            // dropOff = state.endDate + ' ' + state.endTime;
          }
          break;

        case ServiceTypes.SERVICE_TRANSPORTATION:
          // This component is only available for service type rent
          this.$router.push(routesConst.HOME);
          break;
      }
      axios.get(apiService.vehicleEndpoint() + '?passengers=' + passengers + '&pickup=' + pickup + '&drop_off=' + dropOff)
          .then((response) => {
              this.vehiclesData = <IApiResponseVehicle[]>response.data.data;
          })
          .finally(() => {
              this.loading = false;
          });
    }
  }
})
</script>

<style lang="scss">
@import '../../../sass/variables';

.display-modal {
  display: block;
}

.no-display-modal {
  display: block;
}

.vehicle-card-select-active {
  background-color: rgba(0, 41, 255, 0.03);
  border: 1px solid $blue;
}

</style>